/* eslint import/no-default-export: off */
import Head from "next/head";

export default function FaqLayout({ children }) {

  return (<>
    <div className="">{children}</div>
  </>
  );
}
